import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function Footer() {
  return (
    <footer className="w-full bg-foreground-900 text-background-200" role="contentinfo">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="whitespace-nowrap cursor-pointer">
              <span className="text-xl font-heading font-bold text-background-50">
                每日吃瓜<span className="text-primary-400">黑料</span>
              </span>
            </Link>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
              每日吃瓜黑料为你提供最新、最全、最热的黑料爆料内容。免费吃瓜，黑料每日更新，呱呱吃瓜爆料黑料网曝门黑料，全网热门大瓜一网打尽。
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-5">
              <a href="#subscribe" className="text-foreground-400 no-underline">订阅爆料</a>
            </h4>
            <form
              action="https://readdy.ai/api/form/d92fcnvefssur58kqvdg"
              method="POST"
              encType="application/x-www-form-urlencoded"
              data-readdy-form=""
            >
              <div className="relative">
                <input
                  type="email"
                  name="email"
                  placeholder="输入邮箱获取最新爆料"
                  className="w-full bg-transparent border-0 border-b border-foreground-600 pb-2 text-sm text-background-50 placeholder:text-foreground-500 focus:outline-none focus:border-primary-400 transition-colors"
                  required
                />
                <input
                  type="text"
                  name="company_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  className="website_alt_field"
                />
                <button
                  type="submit"
                  className="absolute right-0 bottom-2 text-primary-400 hover:text-primary-300 transition-colors cursor-pointer"
                  aria-label="订阅"
                >
                  <i className="ri-arrow-right-line text-lg"></i>
                </button>
              </div>
            </form>
            <p className="mt-3 text-xs text-foreground-500">
              订阅即表示同意我们的<a href="#" className="text-primary-400 hover:text-primary-300 underline">隐私政策</a>
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-5">
              快速入口
            </h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/wanghong" className="text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer">网红黑料</Link></li>
              <li><Link to="/category/wangbaomen" className="text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer">网曝门</Link></li>
              <li><Link to="/category/chaoyang" className="text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer">朝阳群众</Link></li>
              <li><Link to="/about" className="text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-5">
              社交媒体
            </h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer" rel="nofollow">微博 @每日吃瓜黑料</a></li>
              <li><a href="#" className="text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer" rel="nofollow">微信公众号</a></li>
              <li><a href="#" className="text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer" rel="nofollow">抖音 @吃瓜中心</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-700">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10">
          <div className="relative overflow-hidden">
            <span className="block text-[12vw] md:text-[10vw] font-heading font-bold text-foreground-800 leading-none select-none tracking-tighter">
              吃瓜
            </span>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-between mt-6 gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 每日吃瓜黑料. 本站内容仅供娱乐参考，不构成任何建议。
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <a href="#" className="hover:text-primary-300 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="hover:text-primary-300 transition-colors cursor-pointer">用户协议</a>
              <a href="#" className="hover:text-primary-300 transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}